<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card title="Account" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.avatar" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ user_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td><a :href="'mailto:'+user_data.email">{{ user_data.email }}</a></td>
              </tr>
              <tr v-if="user_data.mobile">
                <td class="font-semibold">Mobile</td>
                <td><a :href="'tel:'+user_data.mobile">{{ user_data.mobile }}</a></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Verified</td>
                <td>{{ user_data.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Role</td>
                <td>Bride</td>
              </tr>
            </table>
          </div>
        
        </div>
      </vx-card>

      <!-- Tabs -->
      <vx-card>
        <vs-tabs :value="tab">
          <vs-tab label="Events" icon-pack="feather" icon="icon-umbrella" v-if="user_data.events.length">
            <div>
              <vs-table @selected="directToEvent" max-items="10" pagination :data="user_data.events">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>County</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Event Date</vs-th>
                  <vs-th>Service Request</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].county_name }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].location }}</vs-td>

                    <vs-td :data="data[indextr].event_date">{{ data[indextr].event_date }}</vs-td>

                    <vs-td :data="data[indextr].service_requests">{{ data[indextr].service_requests }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Service Requests" icon-pack="feather" icon="icon-package" v-if="user_data.service_request.length">
            <div>
              <vs-table @selected="directToServiceRequest" max-items="10" pagination :data="user_data.service_request">
                <template slot="thead">
                  <vs-th>Event Name</vs-th>
                  <vs-th>Event Date</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Budget</vs-th>
                  <vs-th>Quotes</vs-th>
                  <vs-th sort-key="quote_already_accepted">Accepted</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].event.name">{{ data[indextr].event.name }}</vs-td>

                    <vs-td :data="data[indextr].event.event_date">{{ data[indextr].event.event_date }}</vs-td>

                    <vs-td :data="data[indextr].event.location">{{ data[indextr].event.location }}</vs-td>

                    <vs-td :data="data[indextr].budget">${{ data[indextr].budget }}</vs-td>

                    <vs-td :data="data[indextr].no_of_quotes">{{ data[indextr].no_of_quotes }}</vs-td>

                    <vs-td :data="data[indextr].quote_already_accepted"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].quote_already_accepted ? 'text-primary' : 'text-grey')]" /></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  data () {
    return {
      user_data: null,
      user_not_found: false,
      tab: 0
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    }
  },
  methods: {
    directToEvent (tr) {

    },
    directToServiceRequest (tr) {
      this.$router
        .push(`/promoter/service-request/view/${tr.id}`)
        .catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "app-user-list" })
      this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch('userManagement/deleteUser', this.user_data.id)
      //   .then(()   => { this.$router.push({name:'admin-user-bride'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The user was successfully deleted'
      })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Users - Bride')
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const userId = this.$route.params.id
    this.$store
      .dispatch('userManagement/fetchUser', {
        userId,
        action : 'view',
        role : 'bride'
      })
      .then((res) => {
        this.user_data = res.data.data

        if (this.$route.query.tab === 'service-request' && this.user_data.service_request.length) {
          this.tab = 1
        } else if (this.$route.query.tab === 'transaction') {
          if (this.user_data.service_request.length && this.user_data.transactions.length) {
            this.tab = 2
          } else {
            this.tab = 1
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
